import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Draggable from 'react-draggable'
import * as Colors from '@material-ui/core/colors'
const selectedColor = Colors.lightGreen['700']

const styles = theme => ({
  flatButton: {
    minWidth: '100%',
    minHeight: '100%',
    margin: 0,
    padding: 0
  },
  flatButtonRunning: {
    minWidth: '100%',
    minHeight: '100%',
    margin: 0,
    padding: 0,
    color: selectedColor,
    border: `1px solid ${selectedColor}`
  },
  flatButtonWhite: {
    minWidth: '100%',
    minHeight: '100%',
    margin: 0,
    padding: 0,
    color: 'white'
  },
  selectedPaper: {
    backgroundColor: selectedColor,
    color: 'white'
  },
  currentPaper: {
    backgroundColor: theme.palette.secondary.dark,
    color: 'white'
  }
})

export default withStyles(styles)(
  class SelectableTableComponent extends Component {
    static propTypes = {
      classes: PropTypes.object.isRequired,
      table: PropTypes.object.isRequired,
      selectable: PropTypes.bool.isRequired,
      isSelected: PropTypes.bool,
      currentTransaction: PropTypes.object,
      onSelect: PropTypes.func.isRequired
    }
    static defaultProps = {
      isSelected: false
    }
    handleSelectTable = e => {
      this.props.onSelect(this.props.table)
    }
    render() {
      const {
        classes,
        isSelected,
        table,
        selectable,
        currentTransaction
      } = this.props
      const isCurrent =
        currentTransaction &&
        table.currentTransaction &&
        currentTransaction.key === table.currentTransaction.key
      let tableClass = 'table'
      switch (table.type) {
        case 'american':
          tableClass += ' american'
          break
        case 'pool':
          tableClass += ' pool'
          break
        case 'snooker':
          tableClass += ' snooker'
          break
        case 'carom':
          tableClass += ' carom'
          break
        case 'chinese':
          tableClass += ' chinese'
          break
        default:
          tableClass += ' american'
      }
      tableClass += table.isVertical ? ' vertical' : ' horizontal'
      tableClass += ' small'
      let paperClassName = isSelected
        ? classNames(tableClass, classes.selectedPaper)
        : tableClass
      let buttonClass = isSelected
        ? classes.flatButtonWhite
        : classes.flatButton
      if (isCurrent) {
        paperClassName = classNames(tableClass, classes.currentPaper)
      } else if (table.currentTransaction && !isSelected) {
        buttonClass = classes.flatButtonRunning
      }
      return (
        <Draggable
          bounds={{ top: 0, left: 0 }}
          disabled
          position={{
            x: parseInt(table.posX, 10) / 2,
            y: parseInt(table.posY, 10) / 2
          }}
          grid={[10, 10]}>
          <Paper className={paperClassName} elevation={selectable ? 5 : 1}>
            <Button
              color="inherit"
              disabled={isCurrent || !selectable}
              className={buttonClass}
              onClick={this.handleSelectTable}>
              {table.num}
            </Button>
          </Paper>
        </Draggable>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/SelectionTabsComponent/SelectableTableComponent.js